import ReserveDeskForm from './ReserveDeskForm';

export default ReserveDeskForm;
